import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface calculateBilling {
  data: [] | null;
}

const initialState: calculateBilling = {
  data: null,
};

export const calculateBillingSlice = createSlice({
  name: 'calculateBilling',
  initialState,
  reducers: {
    setCalculateBilling: (state, action) => {
        state.data = action.payload.data;
    },
    
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setCalculateBilling, reset } = calculateBillingSlice.actions;

// selectors
export const getCalculateBillingData = (state: RootState) => state.calculateBilling.data;

export default calculateBillingSlice.reducer;
